import { Component, OnInit } from '@angular/core';
import {StatsService} from '../../../phone/analytics/stats/services/stats.service';
import {Stats} from '../../../phone/analytics/stats/model/stats';
import {WebSocketService} from '../../service/web-socket-service';
import {Report} from '../../data/health/Report';

import {Observable} from 'rxjs/Rx';

import * as _ from 'underscore';
import {ModalService} from 'ngx-dynamic-modal';
import {LastPortalStatsComponent} from '../../../phone/analytics/stats/components/modal/last-portal-stats/last-portal-stats.component';
import {Router} from '@angular/router';

import * as moment from 'moment';
import {LocalStorageService} from 'ngx-webstorage';
import {AuthService} from '../../service/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    reloadingStats: boolean = false;
    statsData: Stats;
    statsCampaignData: Array<Object> = [];
    statsVerificationData: Object = {};

    statsVerificationDataShow: Object = {};
    statsAlerts: Object;
    statsDialPatterns: Object;

    spammedCallerIds: Array<Object> = [];

    alerts: Array<Object> = [];

    loadingPortalVerification: Object = {};

    constructor(private stats: StatsService, private ws: WebSocketService, private modaHandler: ModalService, private router: Router,
      private localStorage: LocalStorageService, private auth: AuthService) {
        this.statsData = new Stats();
        this.statsAlerts = { 'KO' : [], 'UNKNOWN' : [], 'CONGESTIONS' : [], 'dates' : {} };
        this.statsDialPatterns = {};
    }

    hasClientPk(): boolean {
      return this.auth.getClient() > 0;
    }

    reloadStats(): void {
        this.getDashboardStats();
    }

    ngOnInit() {
        this.getDashboardStats();
        this.ws.message.subscribe(
            (msg: Object) => {
                if(msg.hasOwnProperty('type') && msg['type'] == 'health_monitor_update'){
                    let report = new Report(msg);
                    this.alerts = report.getFailures();
                }

                if(msg.hasOwnProperty('type') && msg['type'] == 'bo_dashboard_camp_stats'){
                    this.statsCampaignData = msg['camp_stats_data'];
                }

                if(msg.hasOwnProperty('type') && msg['type'] == 'bo_dashboard_portal_stats'){
                    this.statsData.setRowsCount(msg['portal_stats_data']);
                    this.statsData.setHeaders(msg['portal_stats_data']);
                    this.statsData.setRowsAvg(msg['portal_stats_data']);
                }

                if(msg.hasOwnProperty('type') && msg['type'] == 'bo_dashboard_alert_stats'){

                    this.statsAlerts = { 'KO' : [], 'UNKNOWN' : [], 'CONGESTIONS' : [], 'dates' : {} };
                    this.statsAlerts['dates'] = msg['dates'];

                    console.log(msg['alerts_stats_data']);
                    console.log(this.statsAlerts);

                    for(let langPortal in msg['alerts_stats_data']){
                        let data = msg['alerts_stats_data'][langPortal];
                        for(let key in data){
                            if(key.indexOf('_CONV') >= 0 && data[key] > 5){
                                let countKey = key.replace('_CONV', '');
                                this.statsAlerts[countKey].push({
                                    'portal' : langPortal,
                                    'count' : data[countKey] + '/' + data[countKey + '_TOTAL'],
                                    'avg' : data[key]
                                })
                            }
                        }
                    }
                }

                if(msg.hasOwnProperty('type') && msg['type'] == 'bo_dashboard_dial_pattern_stats'){
                    this.statsDialPatterns = msg['dial_pattern_data'];
                }

                if(msg.hasOwnProperty('type') && msg['type'] == 'bo_dashboard_caller_ids_spammed'){
                  this.spammedCallerIds = msg['spammed_caller_ids'];
                }
            }
        );
    }

    isSuccessRow(row: Array<Object>): boolean {
        let idx = _.findIndex(row, (obj) => {
            return (
                (obj['label'].match(/PERSON/g) && parseFloat(obj['value']) > 8)
            );
        });

        return (idx >= 0);
    }

    isWarningRow(row: Array<Object>): boolean {
        let idx = _.findIndex(row, (obj) => {
            return (
                (obj['label'].match(/PERSON/g) && parseFloat(obj['value']) < 8)
            );
        });

        return (idx >= 0);
    }

    isDangerRow(row: Array<Object>): boolean {
        let idx = _.findIndex(row, (obj) => {
            return (obj['label'].match(/PERSON/g) && parseFloat(obj['value']) < 4);
        });

        return (idx >= 0);
    }

    showMoreData(row: any): void {
        const langPortal = row[0].value;
        this.modaHandler.addDynamicComponent(LastPortalStatsComponent, {lang_portal: langPortal, current: row});
    }

    showMoreCampaignData(row: any, langPortal: string): void {
        const campName = row[0].value;
        this.modaHandler.addDynamicComponent(LastPortalStatsComponent, {camp_name: campName, lang_portal: langPortal, current: row});
    }

    goToStats(row: any): void {
        let langPortal = row[0].value.split('_');
        let queryParams = {
            'start_date': moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
            'end_date': moment().format('YYYY-MM-DD HH:mm:ss'),
            'lang' : langPortal[0],
            'portal' : langPortal[1]
        };

        this.localStorage.store('stats.dashboard.portal_params', JSON.stringify(queryParams));
        this.router.navigate(['phone/analytics/stats']);
    }

    getPortalVerificationStats(portalLang: string): void {

        if(!this.statsVerificationDataShow.hasOwnProperty(portalLang) || !this.statsVerificationDataShow[portalLang]){
            this.statsVerificationDataShow[portalLang] = true;
            if(!this.statsVerificationData.hasOwnProperty(portalLang)){
                this.loadingPortalVerification[portalLang] = true;
                this
                    .stats
                    .getDashboardPortalVerificationStats({'portal_lang' : portalLang})
                    .subscribe(
                        (result) => {
                            this.statsVerificationData[portalLang] = new Stats();
                            this.statsVerificationData[portalLang].setRowsCount(result);
                            this.statsVerificationData[portalLang].setHeaders(result);
                            this.statsVerificationData[portalLang].setRowsAvg(result);

                            this.loadingPortalVerification[portalLang] = false;
                        }
                    )
            }
            else{
                this.statsVerificationDataShow[portalLang] = true;
            }
        }
        else{
            this.statsVerificationDataShow[portalLang] = false;
        }
    }

    isMonitorUser(): boolean {
        return (this.auth.getUser()['email'] == 'ignacio.colomina@adsalsa.com');
    }

    getPortalFromLangPortal(langPortal: string) {
        return langPortal.split('_')[0];
    }

    hasStatsDialPatterns(){
        return !_.isEmpty(this.statsDialPatterns);
    }

    protected getDashboardStats(): void {
        this.reloadingStats = true;

        Observable
            .forkJoin(this.stats.getDashboardStats(), this.stats.getDashboardCampaignStats())
            .subscribe(
                (results) => {
                    this.statsData.setRowsCount(results[0]);
                    this.statsData.setHeaders(results[0]);
                    this.statsData.setRowsAvg(results[0]);

                    this.statsCampaignData = results[1];

                    this.reloadingStats = false;
                }
            )
        ;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/dashboard/dashboard.component.ts